import { Component } from '@angular/core';
import { ApartmentTypeDetailsBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-apartment-type-details',
  templateUrl: './apartment-type-details.component.html',
  styleUrls: ['./house-details.component.scss']
})

export class ApartmentTypeDetailsComponent extends ApartmentTypeDetailsBaseComponent {
  compareString(a: any, b: any): number {
    if (a.project.name < b.project.name)
      return -1;
    if (a.project.name > b.project.name)
      return 1;
    return 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/houses/apartment-type-details.component.ts